import ProcessFlow from "~/models/processFlows/processFlow"
import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import IterationStep from "~/models/processFlows/steps/iterationStep"
import {ProcessFlowStepType} from "~/enums/processFlowStepType"
import {ReferencePath} from '~/models/referencePaths/referencePath'
import {Hash} from '~/interfaces/hashInterfaces'
import {ObjectHelper} from '~/helpers/objectHelper'
import {IReferencePath} from "~/interfaces/referencePathInterfaces"
import {IAnyProcessFlowCallToAction, ISendNotificationStep} from "~/interfaces/processFlowInterfaces"
import {DefaultEmailStyle} from "~/enums/defaultEmailStyle"
import ProcessFlowCallToActionContainer from '~/mixins/processFlowCallToActionContainer'

export class ProcessFlowSendNotificationStep extends ProcessFlowCallToActionContainer(ProcessFlowStep) implements ISendNotificationStep {
  step_type: ProcessFlowStepType.SendNotification
  deliver_via_in_system: boolean
  deliver_via_email: boolean
  to_recipient_reference_paths: Hash<ReferencePath> = {}
  cc_recipient_reference_paths: Hash<ReferencePath> = {}
  attached_document_reference_paths: Hash<IReferencePath> = {};
  subject: string
  body: string
  has_call_to_action: boolean
  call_to_action: IAnyProcessFlowCallToAction = null
  email_style: DefaultEmailStyle

  constructor(parent: ProcessFlow | IterationStep, options?) {
    super(parent, options)
    this.defineProperty('deliver_via_in_system', true)
    this.defineProperty('deliver_via_email', false)
    this.defineProperty('to_recipient_reference_paths', {})
    this.defineProperty('cc_recipient_reference_paths', {})
    this.defineProperty('subject', '')
    this.defineProperty('body', '')
    this.defineProperty('has_call_to_action', false)
    this.defineProperty('email_style', DefaultEmailStyle.Default)

  }

  get defaultTitle(): string {
    return this.subject ? this.subject : `Send Notification Step`
  }

  get toRecipientReferencePathsArray(): ReferencePath[] {
    return ObjectHelper.toArray(this.to_recipient_reference_paths)
  }

  get ccRecipientReferencePathsArray(): ReferencePath[] {
    return ObjectHelper.toArray(this.cc_recipient_reference_paths)
  }

  get attachedDocumentReferencePathsArray(): IReferencePath[] {
    return ObjectHelper.toArray(this.attached_document_reference_paths);
  }
}